/**
 * 备注
 */
import React from 'react';
import intl from 'react-intl-universal';

import { renderContent } from '@/utils';
import ContentBlock from '@/components/Reservation/ContentBlock';
import { useDetailData } from '@/pages/reservation/reverseRollback/helper';

import styles from './index.module.scss';

const Index = () => {
  const { remark, checkinRemark } = useDetailData();

  return (
    <>
      <ContentBlock title={intl.get('app_reservation_reserve_remark')}>
        {renderContent(remark)}
      </ContentBlock>
      <ContentBlock title={intl.get('app_reservation_checkin_remark')}>
        {renderContent(checkinRemark)}
      </ContentBlock>
      <div className={styles.hintMessageWrapper}>
        <p>{intl.get('drawer_extension_rollback_remark_p1')}</p>
        <p>{intl.get('drawer_extension_rollback_remark_p2')}</p>
        <p>{intl.get('drawer_extension_rollback_remark_p3')}</p>
        <p>{intl.get('drawer_extension_rollback_remark_p4')}</p>
        <p>{intl.get('drawer_extension_rollback_remark_p5')}</p>
      </div>
    </>
  );
};

export default Index;
